const collaborator =[{
    name:"volkswagen",
    image:"volkswagen.jpg"
},
{
    name:"mozilla",
    image:"mozilla.jpg"
},
{
    name:"iiit palakkad",
    image:"iit_palakkad.jpeg"
},
{
    name:"ICMR",
    image:"main_logo.svg"
},
]
export default collaborator;